import styled from 'styled-components';

export const InfoCardStyled = styled.div`
    .container{
        padding: 32px 0;
        &::before {
            background: linear-gradient(rgb(241, 246, 251) 0px, rgb(255, 255, 255) 50px);
        }
    }
    .vertical-col {
        display: flex;
        flex-direction: row;
    }
    .info-card-title {
        color: ${(props) => props?.theme?.color?.neutral?.black};
        font-family: 'Mulish';
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 23px;
    }
    .info-card-subtitle {
        color: ${(props) => props?.theme?.color?.neutral?.black};
        font-family: 'Mulish';
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 23px;
        text-overflow: ellipsis;
    }
    .info-card-parent {
        border: 1px solid ${(props) => props?.theme?.color?.borderLight};
        border-radius: 16px;
        .info-card-image {
            border: 1px solid ${(props) => props?.theme?.color?.borderLight};
            border-top-right-radius: 16px;
            border-top-left-radius: 16px;
            overflow: hidden;
            cursor: pointer;
        }
        .info-card-content {
            padding: 16px;
            .info-card-text {
                height: 46px;
                margin:0;
                color: ${(props) => props?.theme?.color?.neutral?.black};
                font-family: 'Mulish';
                font-size: 16px;
                font-style: normal;
                font-weight: 700;
                line-height: 23px;
                overflow:hidden;

            }
            .info-card-subtext {
                color: ${(props) => props?.theme?.color?.neutral?.black};
                height: 46px;
                font-family: 'Mulish';
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: 23px;
                overflow: hidden;
            }
            .info-card-button {
                width: 50%;
                color:  ${(props) => props?.theme?.colors?.neutral?.white};
                text-align: center;
                font-family: 'Mulish';
                font-size: 14px;
                font-style: normal;
                font-weight: 700;
                line-height: 20px;
            }
        }
    }
    @media (max-width: 768px) {
        .info-card-parent{
            .info-card-content{
                .info-card-button {
                    width: 100%;
                }
            }
        }
    }

    @media (max-width: 500px) {
        .vertical-col {
            flex-direction: column;
        }
        .info-card-parent{
            .info-card-content {
                .info-card-text {
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    text-overflow: ellipsis;
                }
                .info-card-subtext {
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    text-overflow: ellipsis;
                }
            }
        }
        .info-card-button {
            width: 100%;
        }
    }
`;